// @flow

import * as React from 'react';

import { useTranslator } from '@gandi/translate';
import { Text } from '@gandi/ui';
import {
  ListCell,
  ListItem,
  ListLoader,
  ListRow,
  TitleCell,
} from '@gandi/ui/deprecated';

import { useAccount } from '../modules/account';

export type Props = {
  additionalPrice?: number,
};

function Consumption({ additionalPrice }: Props): React.Node {
  const { __, formatPrice } = useTranslator();

  const { account, isFetchingAccount } = useAccount();

  return (
    <>
      <ListRow separatorBottom>
        <ListItem>
          <TitleCell>
            {additionalPrice
              ? __('Cost of Cloud resources for 30 days')
              : __('Cloud resources consumption')}
          </TitleCell>
        </ListItem>
      </ListRow>
      <ListRow>
        <ListItem>
          <ListCell>
            <Text color="base" size="base" weight="regular">
              {__('Cloud Account balance')}
            </Text>
          </ListCell>
          {isFetchingAccount ? (
            <ListLoader />
          ) : (
            <ListCell type="secondary">
              <Text color="base" size="base" weight="semibold">
                {account?.balance
                  ? formatPrice(
                      account.balance?.price_after_taxes,
                      account.balance?.currency,
                    )
                  : '-'}
              </Text>
            </ListCell>
          )}
        </ListItem>
      </ListRow>
      <ListRow separatorBottom>
        <ListItem>
          <ListCell>
            <Text color="base" size="base" weight="regular">
              {additionalPrice
                ? __('Current cost')
                : __('Cost of Cloud resources for 30 days')}
            </Text>
          </ListCell>
          {isFetchingAccount ? (
            <ListLoader />
          ) : (
            <ListCell type="secondary">
              <Text
                color="base"
                size="base"
                weight={additionalPrice ? 'regular' : 'semibold'}
              >
                {account?.consumption
                  ? formatPrice(
                      !account.consumption.current.normal_price_after_taxes ||
                        account.automatic
                        ? account.consumption.current.price_after_taxes
                        : account.consumption.current.normal_price_after_taxes,
                      account.consumption.current.currency,
                    )
                  : '-'}
              </Text>
            </ListCell>
          )}
        </ListItem>
      </ListRow>
      {
        // $FlowFixMe[sketchy-number-and]
        additionalPrice && (
          <ListRow separatorBottom>
            <ListItem>
              <ListCell>
                <Text color="base" size="base" weight="regular">
                  {__('New cost')}
                </Text>
                &nbsp;
                <Text color="light" size="base" weight="regular">
                  {__('Current cost + New resources')}
                </Text>
              </ListCell>
              {isFetchingAccount ? (
                <ListLoader />
              ) : (
                <ListCell type="secondary">
                  <Text color="base" size="base" weight="semibold">
                    {account?.consumption
                      ? formatPrice(
                          account.consumption.current.price_after_taxes +
                            additionalPrice,
                          account.consumption.current.currency,
                        )
                      : '-'}
                  </Text>
                </ListCell>
              )}
            </ListItem>
          </ListRow>
        )
      }
    </>
  );
}

export default Consumption;
